// extracted by mini-css-extract-plugin
export var block = "styles-module--block--487e7";
export var body = "styles-module--body--4d117";
export var button = "styles-module--button--c92b5";
export var buttonWrapper = "styles-module--buttonWrapper--3b215";
export var header = "styles-module--header--f3a55";
export var inverted = "styles-module--inverted--e63db";
export var text = "styles-module--text--e604b";